import { baseFetchExtension } from "./fetching/baseFetchExtension";
import { baseFetchWeb } from "./fetching/baseFetchWeb";
import { checkIsExtension } from "./helpers/helpers";
/**
 * Fetches data from a remote server using either the extension or web API.
 *
 * @template Params - The type of parameters required for the fetch operation.
 * @template R - The type of data returned by the fetch operation.
 * @template SHOW_HTTP_DATA - A boolean indicating whether or not to include the raw HTTP response data in the returned value. Defaults to false.
 *
 * @param {IFetchInput<Params, SHOW_HTTP_DATA>} params - The input parameters for the fetch operation.
 * @returns {Promise<R | { data: R; __httpData: Response }>} - A Promise containing the fetched data or an object containing the fetched data and the raw HTTP response, if SHOW_HTTP
 *_DATA is true.
 */
export const baseFetch = (params) => {
    return checkIsExtension() ? baseFetchExtension(params) : baseFetchWeb(params);
};
